module.exports = __webpack_public_path__ + "static/07-cd47b1455f6bc8e7bfe652206005ded7.jpg";